import { render, staticRenderFns } from "./AiChatContentCard.vue?vue&type=template&id=770e3892&scoped=true"
import script from "./AiChatContentCard.vue?vue&type=script&lang=js"
export * from "./AiChatContentCard.vue?vue&type=script&lang=js"
import style0 from "./AiChatContentCard.vue?vue&type=style&index=0&id=770e3892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e3892",
  null
  
)

export default component.exports